<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>异常用户</span>
    </div>
    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in tabs" :key="index" :label="item.label" :name="item.value">
        <el-table
          :data="tableData"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
            align="center"
          />
          <el-table-column
            prop="reg_date"
            label="注册日期"
            align="center"
          />
          <el-table-column
            prop="level"
            label="等级"
            align="center"
          />
          <el-table-column
            prop="grant"
            label="今日发放"
            align="center"
          />
          <el-table-column
            prop="cost"
            label="今日消耗"
            align="center"
          />
          <el-table-column
            prop="pay"
            label="今日充值"
            align="center"
          />
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { getAbnormalUserStat } from '@/api/statistics/user_remain'
import { getLastDates } from '@/utils'

export default {
  name: 'AbnormalUserStat',
  data() {
    return {
      loading: false,
      tableData: [],
      tabs: [{ label: '金币', value: 'money' }, { label: '体力', value: 'spins' }],
      activeName: 'money',
      queryParams: {
        startDate: '',
        type: 1
      }
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }
    this.getTables()
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables()
    },
    handleClick(tab, event) {
      this.queryParams.type = 1
      if (tab.index == 1) {
        this.queryParams.type = 2
      }
      this.getTables()
    },
    getTables() {
      this.loading = true
      getAbnormalUserStat(this.queryParams).then(res => {
        this.loading = false
        this.tableData = res.data.data
      })
    }
  }
}
</script>

<style scoped>

</style>
